import React, {PropTypes} from 'react';
import classnames from 'classnames';

const PostControls = ({children, displayInline, classNames = ''}) => {
  const cssClass = classnames({
    'post-controls': true,
    'post-controls--inline': displayInline,
  }, classNames);
  const items = React.Children.map(children, (child, index) => {
    if (child === null) {
      return null;
    }
    return (<div className="post-controls__item" key={`post-controls__item-${index}`}>{child}</div>);
  });
  return (
    <div className={cssClass}>
      {items}
    </div>);
};

PostControls.propTypes = {
  children: React.PropTypes.oneOfType([
    React.PropTypes.arrayOf(React.PropTypes.node),
    React.PropTypes.node,
  ]),
  displayInline: PropTypes.bool,
  classNames: PropTypes.string,
};

export default PostControls;

